/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Branch_PlaceholderInputs */

const en_case_field_branch_placeholder = /** @type {(inputs: Case_Field_Branch_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search branch...`)
};

const pt_br2_case_field_branch_placeholder = /** @type {(inputs: Case_Field_Branch_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar filial...`)
};

/**
* | output |
* | --- |
* | "Search branch..." |
*
* @param {Case_Field_Branch_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_branch_placeholder = /** @type {((inputs?: Case_Field_Branch_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Branch_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_branch_placeholder(inputs)
	return pt_br2_case_field_branch_placeholder(inputs)
});